import type { RouteRecordRaw } from 'vue-router';
import { requireFlag } from '@/routes/guards/flag';
import { FeatureFlag } from '@/composables/feature-flags';
import Permission from '@/composables/permissions/permissions';

export default [
  {
    path: 'security-profile/settings',
    name: 'security-profile-settings',
    component: () => import('./SettingsRoot.vue'),
    children: [
      {
        path: 'products',
        name: 'security-profile-settings-products',
        beforeEnter: [requireFlag(FeatureFlag.Products)],
        components: {
          default: () => import('./ProductSettings.vue'),
          hero: () => import('./ProductSettingsHero.vue'),
        },
        meta: {
          permissions: [Permission.SuppliersAssessmentEdit],
        },
      },
      {
        path: 'third-parties',
        name: 'security-profile-settings-third-parties',
        beforeEnter: [requireFlag(FeatureFlag.ShareFourthPartiesSupplierSide)],
        components: {
          default: () => import('./ThirdParties.vue'),
          hero: () => import('./ThirdPartiesHero.vue'),
        },
      },
      {
        path: 'assets',
        name: 'security-profile-settings-assets',
        components: {
          default: () => import('@/modules/external-monitoring/AssetsTable.vue'),
          hero: () => import('./AssetsHero.vue'),
        },
      },
    ],
  },
] satisfies RouteRecordRaw[];
